/**
 *
 */
export enum CountryID {
  India = 166,
  SriLanka = 20,
  Other = -9999,
}
